export default "__VITE_ASSET__5424c309__"